import { DashboardNotifications } from "@dev/ee-api/ee-api-models";

export const personaSurveyNotificationNames = [
    DashboardNotifications.SophieMarketingNotification, 
    DashboardNotifications.AlexMarketingNotification, 
    DashboardNotifications.JakeMarketingNotification, 
    DashboardNotifications.LindaMarketingNotification
];
